<template>
    <div class="home">
        <div class="ctt">
            <div class="qrcode-yyq" :class="{active:isQrcodeOpen}" @click="closeQrcode">
                <div class="qrcode-container" @click.stop>
                    <p class="title">
                        <img :src="onlineServiceIconSrc" alt="online-service-icon">
                        <span @touchend="callService">在线客服</span>
                    </p>
                    <p class="hot-line-number">
                        <img :src="telServiceIconSrc" alt="tel-service-icon">
                        <span>
                            <a :href="'tel:'+serviceTel" class="text">电话客服</a>
                        </span>
                    </p>
                    <img :src="homeCloseBtnSrc" alt="close-btn" class="close" @click="closeQrcode">
                </div>
            </div>
            <div class="home-background">
                <img :src="homeBgSrc" alt="home-bg.png">
                <div class="search-wrapper" @click.stop="beforeSearch" ref="search">
                    <img :src="searchIconSrc" alt="search-icon" class="search-icon">
                    <span>搜索你感兴趣的试试</span>
                </div>
                <div class="hot-line" @click="openQrcode">
                    <img :src="hotLineSrc" alt="hot-line">
                </div>
                <transition name="fade-search">
                    <search-result @show:footer="isFooterShow = true" ref="sinput"></search-result>
                </transition>
                <div class="swiper-wrapper" v-show="bannerImages.length > 0">
                    <van-swipe
                        :autoplay="3000"
                        :width="670"
                        :show-indicators="true"
                        class="swiper-container"
                    >
                        <van-swipe-item v-for="(item, index) in bannerImages" :key="index">
                            <img
                                class="home-swipe-image needsclick"
                                @click="toUrl(item.link)"
                                :src="`${item.url}?x-oss-process=image/resize,w_${swipeWidth*2}`"
                            >
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <div class="banner-wrapper">
                <nav class="boms-nav">
                    <div class="each-nav-item" @click.stop="()=>$router.push({name:'scene'})">
                        <img :src="sceneIconSrc" alt="scene-icon">
                        <span>热门景区</span>
                    </div>
                    <div class="each-nav-item" @click.stop="()=>$router.push({name:'hotel'})">
                        <img :src="hotelIconSrc" alt="hotel-icon">
                        <span>推荐酒店</span>
                    </div>
                    <div class="each-nav-item" @click.stop="()=>$router.push({name:'route'})">
                        <img :src="lineIconSrc" alt="food-icon">
                        <span>线路游</span>
                    </div>
                    <div class="each-nav-item" @click.stop="()=>$router.push({name:'car'})">
                        <img :src="carIconSrc" alt="goods-icon">
                        <span>包租车</span>
                    </div>
                    <div class="each-nav-item" @click.stop="()=>$router.push({name:'goods'})">
                        <img :src="goodsIconSrc" alt="scene-icon">
                        <span>特产商品</span>
                    </div>
                    <div class="each-nav-item" @click.stop="()=>$router.push({name:'wenchuang'})">
                        <img :src="wenchuangIconSrc" alt="hotel-icon">
                        <span>文创精品</span>
                    </div>
                      <div class="each-nav-item" @click.stop="()=>$router.push({name:'camping'})">
                        <img :src="campingIconSrc" alt="scene-icon">
                        <span>沙漠露营</span>
                    </div>
                    <div class="each-nav-item" @click.stop="redirectToForwardPage">
                        <img :src="forwardIconSrc" alt="hotel-icon">
                        <span>敬请期待</span>
                    </div>
                </nav>
            </div>
            <div class="content-wrapper">
                <div class="each-content" v-if="tmpData.scenicSpot&&tmpData.scenicSpot.length > 0" v-cloak>
                    <div class="each-title">
                        <span>热门景区</span>
                        <span class="more-menu" @click.stop="()=>$router.push({name:'scene'})">
                            <img :src="grayRightArrowSrc" alt="gray-right-arrow">
                        </span>
                    </div>
                    <div class="sub-title">小驼带你去看不同的风景</div>
                    <div
                        class="scene-content clearfix"
                        :class="tmpData.scenicSpot.length % 2 === 0 ? {'float-4-mode':true}:{'float-mode':true}"
                    >
                        <div
                            class="each-scene"
                            :class="sceneClass(index,tmpData.scenicSpot.length)"
                            v-for="(item,index) of tmpData.scenicSpot"
                            :key="index"
                            @click.stop="()=>$router.push('sceneDetail/'+item.id)"
                        >
                            <img
                                :src="`${item.img}?x-oss-process=image/resize,w_${swipeWidth}`"
                                @error="__change__no__image"
                                class="scene-image"
                            >
                            <div
                                class="shade-wrapper"
                                :class="sceneClass(index,tmpData.scenicSpot.length)"
                            >
                                <img class="scene-map-icon" :src="mapIconSrc" alt="map.png">
                                <h4
                                    class="scene-title text-overflow"
                                    :class="sceneClass(index,tmpData.scenicSpot.length)"
                                    v-text="item.name"
                                ></h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="each-content" v-if="tmpData.hotel&&tmpData.hotel.length > 0" v-cloak>
                    <div class="each-title">
                        <span>精选酒店</span>
                        <span class="more-menu" @click.stop="()=>$router.push({name:'hotel'})">
                            <img :src="grayRightArrowSrc" alt="gray-right-arrow">
                        </span>
                    </div>
                    <div class="sub-title">一座城一间屋，让生活慢下来</div>
                    <div class="hotel-content">
                        <div class="hotel-content-inner">
                            <div
                                class="each-hotel"
                                v-for="(item,index) of tmpData.hotel"
                                :key="index"
                                @click.stop="()=>$router.push('hotelDetail/'+item.id)"
                            >
                                <div class="each-hotel-top">
                                    <img :src="`${item.img}`" class="hotel-iamge" alt="hotel-image">
                                    <!-- <img :src="hotIconSrc" class="hot-icon" alt="hot-icon"> -->
                                    <div class="hotel-background-shadow"></div>
                                    <div class="map-title" v-if="item.city">
                                        <img class="hotel-map-icon" :src="mapIconSrc" alt="map.png">
                                        <h4 class="hotel-title text-overflow">{{item.city}}</h4>
                                    </div>
                                    <div class="info-title">
                                        <div class="info-title-left">
                                            <span v-show="item.level">{{item.level}}星级</span>
                                            <span
                                                v-for="(tag,i) in item.tags"
                                                :key="i"
                                            >{{tag}}</span>
                                        </div>
                                        <div class="info-title-right">
                                            <span>
                                                ￥{{item.salePrice}}
                                                <span class="price-name">起</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="each-hotel-bottom">
                                    <div class="hotel-bottom-titel" v-text="item.name"></div>
                                    <div
                                        class="hotel-buy-btn"
                                        @click.stop="()=>$router.push('hotelDetail/'+item.id)"
                                    >预定</div>
                                </div>
                            </div>
                            <!-- <div class="each-hotel">
                                <div class="each-hotel-top">
                                    <img src="http://boms-test.oss-cn-beijing.aliyuncs.com/boms/1545210754198992051124630.jpg" alt="hotel-image">
                                    <div class="hotel-background-shadow"></div>
                                    <div class="map-title">
                                        <img class="scene-map-icon" src="https://oss.tuoxingwang.com/vaporetto-assets/home/png/map-icon.png" alt="map.png">
                                        <h4 class="scene-title text-overflow">酒泉</h4>
                                    </div>
                                    <div class="info-title">
                                        <div class="info-title-left">
                                            <span>五星级</span>
                                            <span>设备齐全</span>
                                            <span>特惠</span>
                                        </div>
                                        <div class="info-title-right">
                                            <span>￥65元起</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="each-hotel-bottom">
                                    <div class="hotel-bottom-titel">
                                        瓜州水榭景观酒店
                                    </div>
                                    <div class="hotel-buy-btn">
                                        预定
                                    </div>
                                </div>
                            </div>-->
                        </div>
                    </div>
                </div>

                <div class="each-content" v-if="tmpData.specialty&&tmpData.specialty.length > 0" v-cloak>
                    <div class="each-title">
                        <span>嗨购特产</span>
                        <span class="more-menu" @click.stop="()=>$router.push({name:'goods'})">
                            <img :src="grayRightArrowSrc" alt="gray-right-arrow">
                        </span>
                    </div>
                    <div class="sub-title">嗨购给你足够的安全感</div>
                    <div class="goods-content">
                        <div class="row row-even">
                            <div
                                class="each-goods"
                                v-for="(item,index) of tmpData.specialty"
                                :key="index"
                                @click.stop="()=>$router.push('goodsDetail/'+item.id)"
                            >
                                <img
                                    :src="`${item.img}?x-oss-process=image/resize,w_${swipeWidth}`"
                                    @error="__change__no__image"
                                    class="goods-img img-responsive"
                                >
                                <img :src="hotIconSrc" class="hot-icon" alt="hot-icon">
                                <div class="title-wrapper">
                                    <p class="title" v-text="item.name"></p>
                                    <p class="price">
                                        <span>￥</span>
                                        <span class="price-name">{{item.price}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="each-content" v-if="tmpData.wenChuang&&tmpData.wenChuang.length > 0" v-cloak>
                    <div class="each-title">
                        <span>文创精品</span>
                        <span class="more-menu" @click.stop="()=>$router.push({name:'wenchuang'})">
                            <img :src="grayRightArrowSrc" alt="gray-right-arrow">
                        </span>
                    </div>
                    <div class="sub-title">文化与创意满满的品质小物</div>
                    <div class="goods-content">
                        <div class="row row-even">
                            <div
                                class="each-goods"
                                v-for="(item,index) of tmpData.wenChuang"
                                :key="index"
                                @click.stop="()=>$router.push('wenChuangDetail/'+item.id)"
                            >
                                <img
                                    :src="`${item.img}?x-oss-process=image/resize,w_${swipeWidth}`"
                                    @error="__change__no__image"
                                    class="goods-img img-responsive"
                                >
                                <img :src="hotIconSrc" class="hot-icon" alt="hot-icon">
                                <div class="title-wrapper">
                                    <p class="title" v-text="item.name"></p>
                                    <p class="price">
                                        <span>￥</span>
                                        <span class="price-name">{{item.price}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-service-wrapper"></div>
        </div>
        <boms-footer :is-show="isFooterShow" :active="0"></boms-footer>
    </div>
</template>

<script>
import SearchResult from "@/components/SearchResult";

export default {
    name: "Home",
    data() {
        return {
            show: false,
            bannerImages: [],
            isFooterShow: true,
            tmpData: {
                scenicSpot: [],
                hotel: [],
                specialty: [],
                ticket: [],
                wenChuang: []
            },
            serviceTel: "0931-8455399-803",
            swipeWidth: window.innerWidth,
            isQrcodeOpen: false,
            isWXSharePage: true,
            telServiceIconSrc: "",
            onlineServiceIconSrc: "",
            homeCloseBtnSrc: "",
            homeBgSrc: "",
            searchIconSrc: "",
            hotLineSrc: "",
            sceneIconSrc: "",
            hotelIconSrc: "",
            lineIconSrc: "",
            carIconSrc: "",
            goodsIconSrc: "",
            campingIconSrc: "",
            forwardIconSrc:"",
            wenchuangIconSrc: "",
            grayRightArrowSrc: "",
            mapIconSrc: "",
            hotIconSrc: ""
        };
    },
    components: { SearchResult },
    computed: {},
    mounted() {
        this.telServiceIconSrc = API.ossUrl + "home/png/tel-service-icon.png";
        this.onlineServiceIconSrc =
            API.ossUrl + "home/png/online-service-icon.png";
        this.homeCloseBtnSrc = API.ossUrl + "home/png/home-close-btn.png";
        this.homeBgSrc = API.ossUrl + "home/png/home-bg.png?param=1";
        this.searchIconSrc = API.ossUrl + "home/png/search-icon.png";
        this.hotLineSrc = API.ossUrl + "home/png/hot-line.png";
        this.sceneIconSrc = API.ossUrl + "home/png/scene-icon.png";
        this.hotelIconSrc = API.ossUrl + "home/png/hotel-icon.png";
        this.lineIconSrc = API.ossUrl + "home/png/line-icon.png";
        this.carIconSrc = API.ossUrl + "home/png/car-icon.png";
        this.goodsIconSrc = API.ossUrl + "home/png/goods-icon.png";
        this.wenchuangIconSrc = API.ossUrl + "home/png/wenchuang-icon.png";
        this.grayRightArrowSrc = API.ossUrl + "home/png/gray-right-arrow.png";
        this.mapIconSrc = API.ossUrl + "home/png/map-icon.png";
        this.hotIconSrc = API.ossUrl + "home/png/hot-icon.png";
        this.campingIconSrc = API.ossUrl+"home/png/camping.png";
        this.forwardIconSrc = API.ossUrl+"home/png/forward.png";
        if (localStorage["history-record"]) {
            this.historyRecord = JSON.parse(localStorage["history-record"]);
        }
    },
    created() {
        if (sessionStorage.getItem("firstEnter") == "first") {
            return;
        }
        const shareToName = UTILS.getQueryString("shareto");
        const shareId = UTILS.getQueryString("shareid");
        sessionStorage.setItem("firstEnter", "first");
        sessionStorage.setItem("fromHome","fromHome");
        if (shareToName) {
            if (shareId) {
                this.$router.push(`/${shareToName}/${shareId}`);
            } else {
                this.$router.push(`/${shareToName}`);
            }
        }
    },
    activated() {
        this.isWXSharePage = true;
        this.getHomepageData();
    },
    deactivated() {
        this.isWXSharePage = false;
        this.bannerImages = [];
    },
    beforeRouteEnter(to, from, next) {
        if (UTILS.getQueryString("promoteStr")) {
            localStorage.promoteStr = UTILS.getQueryString("promoteStr");
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === "getAuth") {
            sessionStorage.setItem("exit", "1");
            UTILS.closeWindow();
            return;
        }
        next();
    },
    watch: {
        $route(to, from) {
            if (from.query.search) {
                this.$refs.sinput.searchCancel();
            }
        }
    },
    methods: {
        redirectToForwardPage(){
            this.$toast("服务持续升级，敬请期待");
        },
        hotline() {
            this.show = true;
        },
        sceneClass(i, length) {
            if (length === 1) return { special: true };
            if (length === 2)
                return {
                    md: i === 1,
                    special: i === 0
                };
            if (length === 3)
                return {
                    lg: i === 0,
                    md: i === 1,
                    sm: i === 2,
                    special: i === 0
                };
            if (length > 3)
                return {
                    lg: i === 0,
                    md: i === 1 || i === 3,
                    sm: i === 2 || i === 4,
                    special: i === 0
                };
        },
        toUrl(link) {
            if (link) {
                location.href = link;
            }
        },
        beforeSearch() {
            //操作dom是因为mobile safari下必须用户点击之后的[同步]操作focus()才有效
            //但vue的 nextTick dom更新是异步的
            //https://stackoverflow.com/a/16601288
            this.$router.push("/home?search=1");
            document.querySelector(".search-wrapper-real").style.display =
                "block";
            document
                .querySelector('.van-field__control[type="search"]')
                .focus();
            this.isFooterShow = false;
        },
        getHomepageData() {
            this.$axios
                .get(window.API.homepage)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.tmpData = data.data;
                        this.bannerImages = data.data.rotation;
                        this.tmpData.hotel.forEach((e, index) => {
                            let levelArr = ["一", "二", "三", "四", "五"];
                            if (e.level) {
                                let levelValue = e.level;
                                e.level = levelArr[levelValue - 1];
                            }
                        });
                        if (
                            this.isWXSharePage &&
                            sessionStorage.getItem("title") !==
                                `${API.projectName}-首页`
                        ) {
                            this.isWXSharePage = false;
                            window.global.getConfig({
                                title: `${API.projectName}-首页`,
                                link: `${window.location.origin}?shareto=home`,
                                imgUrl: `${
                                    data.data.rotation[0]
                                        ? data.data.rotation[0].url +
                                          "?x-oss-process=image/resize,m_fill,h_256,w_256"
                                        : ""
                                }`,
                                desc: ``
                            });
                        }
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        },
        callService() {
            let baiduBtn = document.querySelector("#nb_icon_wrap");
            if (baiduBtn) {
                baiduBtn.click();
            }
        },
        closeQrcode(mode) {
            this.isQrcodeOpen = false;
            if (typeof mode === "object") {
                this.$router.go(-1);
            }
        },
        openQrcode() {
            const fullPath = this.$route.fullPath;
            const query = fullPath.indexOf("?") === -1 ? "?mdl=1" : "&mdl=1";
            this.$router.push(`${fullPath}${query}`);
            this.isQrcodeOpen = true;
        }
    }
};
// 兰州水上巴士改版再加百度商桥
var _hmt = _hmt || [];
(function() {
    var hm = document.createElement("script");
    hm.async = "async";
    hm.src = "https://hm.baidu.com/hm.js?1b455a1bee65d51ebc7e64d52b511813";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();

//兰州水上巴士（txw）改版再加百度商桥
// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//    hm.async = "async";
//   hm.src = "https://hm.baidu.com/hm.js?64445ad39f0dd745bbc25973d86865e4";
//   var s = document.getElementsByTagName("script")[0]; 
//   s.parentNode.insertBefore(hm, s);
// })();

// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.async = "async";
//   hm.src = "https://hm.baidu.com/hm.js?64445ad39f0dd745bbc25973d86865e4";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();
</script>


<style lang="scss" scoped>
.home {
    display: flex;
    flex-direction: column;
    padding-bottom: env(safe-area-inset-bottom);
    .qrcode-yyq {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        transition: 0.3s;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        z-index: -1;
        opacity: 0;
        &.active {
            z-index: 10000;
            opacity: 1;
            .qrcode-container {
                transform: scale(1);
            }
        }
        .qrcode-container {
            width: 7.04rem;
            // height: 4.32rem;
            background: $white;
            transition: 0.3s;
            border: 1px solid rgba(112, 112, 112, 1);
            border-radius: 0.266667rem;
            padding-top: 0.523333rem;
            position: relative;
            text-align: center;
            transform-origin: 100% -15%;
            transform: scale(0);
            .close {
                position: absolute;
                right: 0.32rem;
                top: 0.32rem;
                width: 0.32rem;
                height: 0.32rem;
            }
            .title {
                margin-top: -0.373333rem;
                padding: 0.48rem 0.426667rem 0.213333rem 0.426667rem;
                font-size: 0.426667rem;
                color: #343434;
                border-bottom: 1px solid rgba(235, 235, 235, 1);
                img {
                    display: inline-block;
                    margin-bottom: -3px;
                    margin-right: 0.346667rem;
                    width: 0.586667rem;
                    height: 0.533333rem;
                }
            }
            .hot-line-number {
                font-size: 0.426667rem;
                color: #343434;
                padding: 0 0.416667rem;
                display: flex;
                justify-content: center;
                img {
                    display: block;
                    margin-top: 0.426667rem;
                    margin-right: 0.346667rem;
                    width: 0.586667rem;
                    height: 0.6rem;
                }
                span {
                    display: block;
                    height: 1.4rem;
                    line-height: 1.4rem;
                }
                span:nth-child(1) {
                    color: #707070;
                    margin-right: 0.186667rem;
                }
                .text {
                    margin-top: 0.523333rem;
                    font-size: 0.426667rem;
                    color: #343434;
                    vertical-align: middle;
                    text-decoration: none;
                }
            }
        }
    }
    .home-background {
        width: 100%;
        height: 100%;
        .search-wrapper {
            width: 7.733333rem;
            height: 0.96rem;
            display: flex;
            align-items: center;
            position: absolute;
            top: 0.266667rem;
            left: 0.533333rem;
            right: 0;
            z-index: 10;
            background: $white;
            transition: 0.3s;
            border-radius: 0.44rem;

            .search-icon {
                width: 0.426667rem;
                vertical-align: sub;
                margin-right: 0.303333rem;
                margin-left: 0.266667rem;
                // position: relative;
                top: 1px;
                // margin-left: 0.266667rem;
            }
            span {
                font-family: PingFangSC-Regular;
                color: #666666;
                font-size: 0.373333rem;
                font-weight: 500;
            }
        }
        .hot-line {
            width: 0.8rem;
            height: 0.8rem;
            position: absolute;
            top: 0.266667rem;
            right: 0.533333rem;
            z-index: 10;
            display: block;
        }
        .swiper-wrapper {
            height: 5.173333rem;
            width: 8.933333rem;
            margin: -2.133333rem auto 0;
            // border-radius: 0.266667rem;
            .swiper-container {
                height: 5.173333rem;
                border-radius: 0.266667rem;
                .home-swipe-image {
                    height: 4.533333rem;
                    width: 8.933333rem;
                    border-radius: 0.266667rem;
                }
            }
        }
    }
    .banner-wrapper {
        margin-bottom: 0.613333rem;
        // height: 6.986667rem;
        // position: relative;
        .boms-nav {
            // width: 9.333333rem;
            display: flex;
            align-items: center;
            justify-content: space-around;
            text-align: center;
            margin: 0 auto;
            background: $white;
            flex-wrap: wrap;
            .each-nav-item {
                text-align: center;
                font-size: 0.373333rem;
                font-weight: 500;
                color: #444444;
                line-height: 0.533333rem;
                display: flex;
                flex-direction: column;
                margin-bottom: 0.186667rem;
                width: 25%;
                img {
                    width: 1.96rem;
                    height: 1.96rem;
                    margin: 0 auto;
                }
            }
        }
    }
    .content-wrapper {
        padding: 0 0.533333rem;
        .each-content {
            padding-top: 0.613333rem;
            // padding-bottom: 0.506667rem;
            &:first-child {
                padding-top: 0px;
            }
            &:last-child {
                border-bottom: 0;
            }
            // .each-title {
            //     margin-bottom: 0.08rem;
            //     color: $black;
            //     font-size: 22px;
            //     font-weight: 400;
            //     line-height: 0.8rem;
            // }
            .each-title {
                display: flex;
                justify-content: space-between;
                font-weight: bold;
                color: $black;
                font-size: 0.586667rem;
                .more-menu {
                    height: 0.56rem;
                    img {
                        width: 0.426667rem;
                        height: 0.426667rem;
                    }
                }
            }
            .sub-title {
                font-size: 0.32rem;
                line-height: 0.453333rem;
                color: #8c8c8c;
                padding-top: 0.08rem;
                padding-bottom: 0.373333rem;
                font-weight: 400;
            }
            .scene-content {
                &.float-4-mode {
                    .each-scene {
                        float: left;
                        margin-bottom: 0.266667rem;
                        &:nth-child(2) {
                            margin-right: 0.16rem;
                        }
                    }
                }
                &.float-mode {
                    .each-scene {
                        float: left;
                        // &:nth-child(2),
                        // &:nth-child(3),
                        &:nth-child(3) {
                            float: right;
                        }
                        &:nth-child(4) {
                            margin-right: 0.25rem;
                        }
                        &:nth-child(2) {
                            margin-bottom: 0.16rem;
                        }
                    }
                }

                .each-scene {
                    width: 8.933333rem;
                    height: 4.266667rem;
                    border-radius: 0.266667rem;
                    &:nth-child(1) {
                        margin-bottom: 0.266667rem;
                        &:before {
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 10;
                            content: "";
                            display: block;
                            background: url("https://oss.tuoxingwang.com/vaporetto-assets/home/png/zenbu-icon.png")
                                0 0 no-repeat;
                            background-size: cover;
                            width: 3.733333rem;
                            height: 0.8rem;
                        }
                    }
                    &.lg {
                        width: 8.933333rem;
                        height: 4.266667rem;
                    }
                    &.md {
                        width: 5.946667rem;
                        height: 3.2rem;
                    }
                    &.sm {
                        width: 2.72rem;
                        height: 3.2rem;
                    }
                    &.special {
                        position: relative;
                        width: 8.933333rem;
                        height: 4.266667rem;
                    }
                    position: relative;
                    border-radius: 4px;
                    .scene-image {
                        width: 100%;
                        height: 100%;
                        display: block;
                        border-radius: 0.266667rem;
                    }
                    .shade-wrapper {
                        position: absolute;
                        width: 8.933333rem;
                        height: 1.066667rem;
                        background: linear-gradient(
                            360deg,
                            rgba(0, 0, 0, 0.65) 0%,
                            rgba(0, 0, 0, 0) 100%
                        );
                        left: 0;
                        top: 3.2rem;
                        z-index: 5;
                        border-radius: 0 0 0.266667rem 0.266667rem;
                        &.lg {
                            width: 8.933333rem;
                            height: 1.066667rem;
                            top: 3.23rem;
                        }
                        &.md {
                            width: 5.946667rem;
                            height: 1.066667rem;
                            top: 2.13rem;
                        }
                        &.sm {
                            width: 2.72rem;
                            height: 1.066667rem;
                            top: 2.13rem;
                        }
                        .scene-title {
                            position: absolute;
                            color: $white;
                            bottom: 0.213333rem;
                            left: 0.48rem;
                            width: 87%;
                            font-size: 18px;
                            // &.lg {
                            //     font-size: 22px;
                            // }
                            // &.md {
                            //     font-size: 18px;
                            // }
                            // &.sm {
                            //     font-size: 13px;
                            // }
                        }
                        .scene-map-icon {
                            position: absolute;
                            color: $white;
                            bottom: 0.32667rem;
                            left: 0.08rem;
                            width: 0.426667rem;
                            height: 0.426667rem;
                        }
                    }
                }
            }
            .ticket-content {
                display: flex;
                flex-wrap: nowrap;
                overflow-x: auto;

                .each-ticket {
                    flex: none;
                    .ticket-img {
                        width: 3.333333rem;
                        height: 3.333333rem;
                        margin-right: 0.2rem;
                    }
                    .ticket-title {
                        font-size: 0.4rem;
                        margin: 0.36rem 0 0.25rem;
                        color: $black;
                        font-weight: bold;
                        max-width: 3.52rem;
                        min-height: 1.066667rem;
                        @include multiple-text-overflow(2);
                        word-break: break-all;
                    }
                    .price-row {
                        font-size: 0.32rem;
                        color: #999;
                        .price {
                            font-size: 0.453333rem;
                            color: $orange;
                            font-weight: bold;
                        }
                        .dolar {
                            font-size: 0.373333rem;
                            color: $orange;
                            font-weight: bold;
                        }
                    }
                }
            }

            .hotel-content {
                width: 100%;
                .hotel-content-inner {
                    display: flex;
                    height: 5.306667rem;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    border-radius: 0.266667rem;
                    padding-bottom: 2px;
                    .each-hotel {
                        flex-shrink: 0;
                        width: 8.04rem;
                        // height: 99%;
                        box-shadow: 0px 2px 4px rgba(174, 174, 174, 0.25);
                        border-radius: 0.266667rem;
                        margin-right: 0.266667rem;
                        border: 1px solid transparent;
                        .each-hotel-top {
                            height: 4.026667rem;
                            border-radius: 0.266667rem 0.266667rem 0 0;
                            position: relative;
                            .hotel-iamge {
                                width: 8rem;
                                height: 4.026667rem;
                                border-radius: 0.266667rem 0.266667rem 0 0;
                            }
                            .hot-icon {
                                width: 1.146667rem;
                                height: 0.693333rem;
                                position: absolute;
                                left: 0;
                                top: 0;
                            }
                            .hotel-background-shadow {
                                width: 8rem;
                                height: 1.333333rem;
                                position: absolute;
                                top: 2.693333rem;
                                left: 0;
                                background: linear-gradient(
                                    360deg,
                                    rgba(0, 0, 0, 0.65) 0%,
                                    rgba(0, 0, 0, 0) 100%
                                );
                                border-radius: 0.266667rem 0.266667rem 0 0;
                                z-index: 5;
                            }
                            .map-title {
                                position: absolute;
                                bottom: 0.906667rem;
                                left: 0.266667rem;
                                display: flex;
                                color: $white;
                                .hotel-title {
                                    color: $white;
                                    bottom: 0.213333rem;
                                    left: 0.666667rem;
                                    width: 90%;
                                    font-size: 0.32rem;
                                }
                                .hotel-map-icon {
                                    width: 0.373333rem;
                                    height: 0.373333rem;
                                }
                            }
                            .info-title {
                                position: absolute;
                                bottom: 0.113333rem;
                                left: 0;
                                width: 8rem;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                z-index: 10;
                                .info-title-left {
                                    padding-left: 0.213333rem;
                                    overflow: hidden;
                                    width: 5.013333rem;
                                    height: 0.5867rem;
                                    span {
                                        visibility:visible !important;
                                        padding: 0 0.24rem;
                                        font-size: 0.32rem;
                                        color: $white;
                                        border-radius: 0.16rem;
                                        background: rgba(0, 0, 0, 0.5);
                                        display: inline-block;
                                        margin-right: 0.2667rem;
                                        line-height: 0.5867rem;
                                    }
                                    &:last-child {
                                        margin-right: 0;
                                    }
                                }
                                .info-title-right {
                                    margin-right: 0.213333rem;
                                    z-index: 10;
                                    padding-bottom: 0.133333rem;
                                    span {
                                        font-size: 0.586667rem;
                                        color: $white;
                                    }
                                    .price-name {
                                        font-size: 0.32rem;
                                    }
                                }
                            }
                        }
                        .each-hotel-bottom {
                            height: 1.306667rem;
                            display: flex;
                            justify-content: space-between;
                            padding: 0.293333rem 0.213333rem 0 0.213333rem;
                            border-radius: 0.266667rem;

                            .hotel-bottom-titel {
                                font-size: 0.533333rem;
                                font-weight: 400;
                                line-height: 0.746667rem;
                                color: $grey5;
                            }
                            .hotel-buy-btn {
                                width: 1.76rem;
                                height: 0.853333rem;
                                margin-bottom: 0.213333rem;
                                margin-top: -0.106667rem;
                                background: linear-gradient(
                                    90deg,
                                    rgba(248, 199, 64, 1) 0%,
                                    rgba(245, 149, 38, 1) 100%
                                );
                                border-radius: 0.426667rem;
                                text-align: center;
                                line-height: 0.853333rem;
                                font-size: 0.48rem;
                                font-weight: 400;
                                color: $white;
                            }
                        }
                    }
                }
                .hotel-content-inner::-webkit-scrollbar {
                    display: none;
                }
            }
            .goods-content {
                .row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0.16rem;
                    // display: flex;
                    &.row2 {
                        display: flex;
                        justify-content: flex-start;
                        .each-goods {
                            margin-right: 0.16rem;
                            height: 4.32rem;
                            &:last-child {
                                margin-right: 0px;
                            }
                        }
                    }
                    &.row-even {
                        // display: flex;
                        // justify-content: space-between;
                        flex-wrap: wrap;
                        margin-bottom: 0px;
                        .each-goods {
                            margin-bottom: 0.426667rem;
                            width: 4.32rem;
                            border-radius: 10px;
                            .goods-img {
                                height: 4.32rem;
                                width: 4.32rem;
                            }
                            &:last-child {
                                margin-right: 0px;
                            }
                            // .title {
                            //     // margin: 0.27rem 0 0.19rem;
                            // }
                        }
                    }
                    .each-goods {
                        width: 3rem;
                        height: 100%;
                        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
                        border-radius: 20px;
                        position: relative;
                        .goods-img {
                            width: 100%;
                            overflow: hidden;
                            height: 1.8rem;
                            border-radius: 0.266667rem 0.266667rem 0px 0px;
                        }
                        .hot-icon {
                            width: 1.146667rem;
                            height: 0.693333rem;
                            position: absolute;
                            left: 0;
                            top: 0;
                        }
                        .title-wrapper {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            margin: 0 0.16rem 0 0.213333rem;
                            .title {
                                margin-top: 0.213333rem;
                                font-size: 0.426667rem;
                                color: $grey5;
                                min-height: 1.173333rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                flex-direction: column;
                                line-height: 0.586667rem;
                            }
                            .price {
                                padding: 0 0.16rem 0.186667rem 0rem;
                                margin-top: 0.08rem;
                                font-size: 0.506667rem;
                                color: #ff9200;
                                font-weight: bold;
                                .price-name {
                                    font-size: 0.533333rem;
                                }
                            }
                        }
                    }
                    .each-goods.big {
                        width: 6.2rem;
                        height: 3.466667rem;
                        border-radius: 5px;
                        overflow: hidden;
                        position: relative;
                        .goods-img {
                            width: 100%;
                            height: 100%;
                        }
                        .shader {
                            position: absolute;
                            display: flex;
                            bottom: 0;
                            left: 0;
                            z-index: 10;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0.1333333rem 0.333333rem;
                            background: linear-gradient(
                                to top,
                                rgba(0, 0, 0, 0.6),
                                transparent
                            );
                            width: 100%;

                            .title {
                                font-weight: bold;
                                font-size: 0.4rem;
                                color: $white;
                                margin: 0;
                            }
                            .price {
                                font-size: 0.4rem;
                                font-weight: bold;
                                color: $orange;
                            }
                        }
                    }
                }
            }
        }
    }
    .custom-service-wrapper {
        margin: 0 auto 1.84rem;
    }
}
</style>

